// Local translations for navigation
export const T = {
  en_GB: {
    dashboard: "Dashboard",
    clients: "Clients",
    compliance: "Compliance",
    admin: "Admin",
    settings: "Settings",
  },
  nb_NO: {
    dashboard: "Dashbord",
    clients: "Kunder",
    compliance: "Samsvar",
    admin: "Admin",
    settings: "Innstillinger",
  },
} as const;
